<template>
  <div>
    <ul class="Fuell-Tabs">
      <li class="Fuell-Tabs--tab">
        <router-link
          :to="{name:'transactions_charged'}"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{ path: 'transactions_transactions_subsection_charged' }"
        ></router-link>
      </li>
      <li class="Fuell-Tabs--tab">
        <router-link
          :to="{name:'transactions_authorizations'}"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{ path: 'transactions_transactions_subsections_authorizations' }"
        ></router-link>
      </li>
      <li class="Fuell-Tabs--tab">
        <router-link
          :to="{name:'transactions_declined'}"
          class="Fuell-Tabs--link"
          active-class="active"
          v-t="{ path: 'transactions_transactions_subsections_declined' }"
        ></router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'TransactionsIndex'

}
</script>
